import { Box, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import { BusinessHierarchyItem } from './BusinessHierarchyItem'
interface BusinessHierarchyListProps {
  data: any
  onViewEntities: (data: any) => void
  childList: any[]
  entityLevel: number
}

const BusinessHierarchyList: FC<BusinessHierarchyListProps> = (props: BusinessHierarchyListProps) => {
  const renderItem = ({ index, item }: any) => {
    return (
      <BusinessHierarchyItem
        data={item}
        index={index}
        onViewEntities={props?.onViewEntities}
        childList={props?.childList}
        entityLevel={props?.entityLevel}
      />
    )
  }
  return (
    <Box>
      <FlatList
        data={props?.data}
        renderItem={renderItem}
        ListEmptyComponent={() => <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />}
      />
    </Box>
  )
}

export { BusinessHierarchyList }
